import React from 'react';
import { Box, createStyles, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { ChevronLeft } from '@material-ui/icons';
import TextLink from '@components/TextLink/TextLink';
import TextLinkProps from '@components/TextLink/TextLinkProps';
import { useHomeNavigationContext } from '@components/HeaderSection/NavigationOptions/HomeNavigationContext/HomeNavigationContext';

interface BackLinkProps extends Pick<TextLinkProps, 'onClick' | 'className'> {
	navBackText?: string;
	className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		backBtn: {
			display: 'inline-block',
			marginTop: theme.spacing(5),
		},
	}),
);

export const BackLink = ({ navBackText, onClick, className }: BackLinkProps) => {
	const { handleGoBack } = useHomeNavigationContext();

	const handleBackLinkClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		if (onClick) {
			onClick(e);
		} else {
			handleGoBack();
		}
	};

	const navigateBackText = navBackText || 'Back';
	const classes = useStyles();
	return (
		<Box className={classNames(classes.backBtn, className)}>
			<TextLink
				onClick={handleBackLinkClick}
				prefixIcon={ChevronLeft}
				data-field="navigation-backLink-textLink"
			>
				{navigateBackText}
			</TextLink>
		</Box>
	);
};
